import React, { ReactElement } from "react";
import ReturnSalesReportList from "../../components/Reports/ReturnSalesReport";
import MainLayout from "../../components/Layouts";

const ReturnSalesReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <ReturnSalesReportList />
    </MainLayout>
  );
}; 

export default ReturnSalesReportPage;
